<template>
  <div class="uk-container">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item
        v-if="prevPath.includes('members')"
        :href="'/administration/members/' + bookNum + '/info'"
      >{{fName}} {{lName}}</vk-breadcrumb-item>
      <vk-breadcrumb-item>Edit Union Member</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>Edit {{fName}} {{lName}}</h1>
    <h2>Member Details</h2>
    <form @submit.prevent="putEditedMember">
      <label for="firstName">First Name *</label>
      <input class="uk-input" id="firstName" type="text" v-model="fName" required>
      <label for="lastName">Last Name *</label>
      <input class="uk-input" id="lastName" type="text" v-model="lName" required>
      <label for="bookNumber">Book Number *</label>
      <input class="uk-input" id="bookNumber" type="text" v-model="bookNum" required>
      <label for="registeredDate">Registered Date *</label>
      <el-date-picker
        v-model="registeredDate"
        type="datetime"
        format="MM/dd/yy hh:mm A"
        :default-value="this.registeredDate"
        :value="this.registeredDate"
      ></el-date-picker>
      <label for="expirationDate">Expiration Date</label>
      <el-date-picker
        v-model="expirationDate"
        type="datetime"
        format="MM/dd/yy hh:mm A"
        :default-value="this.expirationDate"
        :value="this.expirationDate"
      ></el-date-picker>
      <label for="phone">Mobile Phone Number</label>
      <input
        class="uk-input"
        v-mask="{mask: '(999) 999-9999'}"
        id="phone"
        type="text"
        v-model="phoneNumber"
      >
      <label for="certifications">Certifications</label>
      <Multiselect
        id="certifications"
        v-model="certifications"
        :options="certOptions"
        :multiple="true"
      ></Multiselect>
      <label for="classifications">Classifications</label>
      <Multiselect
        id="classifications"
        v-model="classifications"
        :options="classOptions"
        :multiple="true"
      ></Multiselect>
      <label for="notes">Notes</label>
      <textarea
        class="uk-textarea uk-margin-bottom"
        name="notes"
        v-model="notes"
        id="notes"
        rows="5"
      ></textarea>
      <span>
        <vk-button class="uk-align-left" v-on:click="goBack">Back</vk-button>
        <input class="uk-button uk-button-primary uk-align-right" type="submit" value="Save Member">
      </span>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MembersApi from "@/utils/api/members";
import OptionsApi from "@/utils/api/options";

export default {
  name: "EditMember",
  components: {
    Multiselect
  },
  data() {
    return {
      fName: "",
      lName: "",
      bookNum: this.$route.params.booknum,
      rDateTime: null,
      registeredDate: "",
      expirationDate: "",
      phoneNumber: "",
      certifications: [],
      certOptions: [],
      classifications: [],
      classOptions: [],
      notes: "",
      prevPath: "/administration"
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevPath = from.fullPath));
  },
  created() {
    OptionsApi.getAllOptions(this.$cookie.get("iwl_apiToken"))
      .then(res => {
        for (var certification of res.certifications) {
          this.certOptions.push(certification.certification);
        }
        for (var classification of res.classifications) {
          this.classOptions.push(classification.classification);
        }
      })
      .catch(err => console.log(err));
    MembersApi.getMember(this.$cookie.get("iwl_apiToken"), this.bookNum)
      .then(res => {
        this.registeredDate = res.registeredDate;
        this.expirationDate = res.expirationDate;
        this.fName = res.fName;
        this.lName = res.lName;
        this.phoneNumber = res.phoneNumber;
        this.certifications = res.certifications;
        this.classifications = res.classifications;
        this.notes = res.notes;
      })
      .catch(err => console.log(err));
  },
  methods: {
    goBack() {
      this.$router.push(this.prevPath);
    },
    putEditedMember() {
      MembersApi.putEditedMember(
        this.$cookie.get("iwl_apiToken"),
        this.$route.params.booknum,
        {
          bookNum: this.bookNum,
          fName: this.fName,
          lName: this.lName,
          phoneNumber: this.phoneNumber,
          areas: [],
          certifications: this.certifications,
          classifications: this.classifications,
          registeredDate: this.registeredDate,
          expirationDate: this.expirationDate,
          notes: this.notes
        }
      )
        .then(res => {
          this.prevPath = this.prevPath.replace(this.$route.params.booknum, this.bookNum);
          this.$router.push(this.prevPath)
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
input,
.multiselect {
  margin-bottom: 20px;
}
input.uk-button {
  margin-bottom: 0px;
}
.el-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_edit_member.vue